import { type ReactNode } from 'react';
import classnames from 'classnames';
import HeroBody from './HeroBody';
import HeroImage from './HeroImage';
import HeroBacklink from './HeroBacklink';

interface HeroProps {
  children: ReactNode;
  fixed?: boolean;
  hasAside?: boolean;
  hasBorderBottom?: boolean;
}

const Hero = ({ children, fixed = false, hasAside = false, hasBorderBottom = false }: HeroProps) => (
  <div
    className={classnames('hero', { 'hero-fixed': fixed, 'border-bottom': hasBorderBottom })}
    style={hasAside ? { left: 380 } : {}}
  >
    <div className="hero__container">{children}</div>
  </div>
);

Hero.Body = HeroBody;
Hero.Image = HeroImage;
Hero.Backlink = HeroBacklink;

export default Hero;
